<csa-carousel-slider
  [slides]="carouselSlides"
  [autoPlay]="autoPlay"
  [currentSlideIndex]="currentSlideIndex"
  [mouseClick]="mouseClick"
  [screenSize]="screenSize"
  [slidesWithMultipleSteps]="carouselSlidesMultipleSteps"
  [otherOptions]="otherOptions"
  (changeSlideSwipe)="handleSlideSwipe($event)"></csa-carousel-slider>
<csa-carousel-footer
  [startButtonText]="startButtonText"
  [previousButtonText]="previousButtonText"
  [nextButtonText]="nextButtonText"
  [screenSize]="screenSize"
  [showIndicators]="showIndicators"
  [slides]="carouselSlides"
  [slidesWithMultipleSteps]="carouselSlidesMultipleSteps"
  [currentSlideIndex]="currentSlideIndex"
  [otherOptions]="otherOptions"
  (startButtonClick)="handleStartButtonClick($event)"
  (changeSlideClick)="handleSlideChange($event)"
  (arrowClick)="handleArrowClick($event)"
  (claimingDialogActionEmitter)="handleClaimingDialogAction($event)"></csa-carousel-footer>
